import {
  Avatar,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  List,
  ListItem,
  ListItemText,
  Rating,
  Stack,
  Typography,
} from "@mui/material";
import { Talent } from "../../types/users";
import { nl2br } from "../../utils/helper";

interface ModalTalentDetailProps {
  open: boolean;
  onClose: () => void;
  talent: Talent | null;
}

const ModalTalentDetail = ({
  open,
  onClose,
  talent,
}: ModalTalentDetailProps) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="md">
      {/* <DialogTitle>{talent?.full_name}</DialogTitle> */}
      <DialogContent>
        <Stack direction={"row"} sx={{ p: 2 }} alignItems="center">
          <Avatar
            alt={`${talent?.first_name}`}
            src={`${talent?.photo?.[0]?.original_url}`}
            sx={{ width: 100, height: 100 }}
          />
          <Box sx={{ ml: 2 }}>
            <Typography variant="h6">{talent?.full_name}</Typography>
            <Typography variant="body2">
              {talent?.city}, {talent?.state} {talent?.zip}
            </Typography>
            <Rating
              value={talent?.total_rating || 0}
              readOnly
              precision={0.5}
            />
          </Box>
        </Stack>
        <Box sx={{ px: 2, pb: 2 }}>
          <Typography sx={{ fontSize: 12 }}>{nl2br(talent?.bio)}</Typography>
        </Box>
        <Divider />

        <List>
          <ListItem>
            <Stack spacing={1} sx={{ mt: 1 }}>
              <Typography sx={{ fontSize: 12 }}>Skills</Typography>
              <Box>
                {talent?.skills?.length == 0 ? (
                  <Typography sx={{ fontSize: 14 }}>No skills added</Typography>
                ) : (
                  talent?.skills?.map((it) => (
                    <Chip label={it.name} key={it.id} sx={{ mr: 1, mb: 1 }} />
                  ))
                )}
              </Box>
            </Stack>
          </ListItem>
          <Divider />
          <ListItem>
            <Stack spacing={1} sx={{ mt: 1 }}>
              <Typography sx={{ fontSize: 12 }}>Languages</Typography>
              <Box>
                {talent?.languages?.length == 0 ? (
                  <Typography sx={{ fontSize: 14 }}>
                    No languages added
                  </Typography>
                ) : (
                  talent?.languages?.map((it) => (
                    <Chip label={it.name} key={it.id} sx={{ mr: 1, mb: 1 }} />
                  ))
                )}
              </Box>
            </Stack>
          </ListItem>
          <Divider />
          <ListItem>
            <Stack spacing={1} sx={{ mt: 1 }}>
              <Typography sx={{ fontSize: 12 }}>More Info</Typography>
              <Box>
                <ListItemText>
                  Rate → {talent?.min_pay} - {talent?.max_pay} $/hr
                </ListItemText>
                <ListItemText>
                  Commute Radius → {talent?.commute_radius} miles
                </ListItemText>
                <ListItemText>
                  COVID-19 vaccine required →{" "}
                  {!!talent?.covid_vaccinated ? "Yes" : "No"}
                </ListItemText>
                <ListItemText>
                  Allow Background Check →
                  {!!talent?.allow_background_check ? "Yes" : "No"}
                </ListItemText>
                <ListItemText>
                  Allow Drug Test → {!!talent?.allow_drug_test ? "Yes" : "No"}
                </ListItemText>
              </Box>
            </Stack>
          </ListItem>
          <Divider />
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ModalTalentDetail;
